import React from 'react';
import Lawyer from './../assets/c.jpg'
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section id="about" className="bg-emerald-500 bg-opacity-10 shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 flex flex-col md:flex-row items-center py-12">
        {/* Text Section */}
        <div className="w-full md:w-1/2 px-4 md:px-8 text-center md:text-left">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Your <span className='text-emerald-600'>Remote </span><br/>In-House Counsel
          </h1>
          <p className="text-xl text-gray-700 mb-6">
            Expert Legal Services. Flexible, Scalable Solutions for Your Business.
          </p>
          <div className="flex justify-center md:justify-start space-x-4">
            {/* <button className="bg-emerald-600 text-white px-6 py-3 rounded-xl hover:translate-y-1">
              Get Started
            </button> */}
            <Link 
              to="services"
              onClick={() => window.scrollTo(0, 0)}
              className="bg-emerald-600 text-white px-6 py-3 rounded-xl hover:translate-y-1"
              // className="border border-emerald-500 text-emerald-600 px-6 py-3 rounded-xl hover:translate-y-1"
              >
              Explore Services
            </Link>
          </div>
        </div>
        {/* Image Section */}
        <div className="w-full md:w-1/2 px-4 md:px-8 mt-8 md:mt-0 ">
          <img
            src={Lawyer}
            alt="Legal Services"
            className="w-full h-auto rounded-t-3xl rounded-b-lg border-2 border-emerald-500 border-opacity-10"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
